<app-add-protection
  *ngIf="additionalServicesService.itemOfferLoaded$ | async"
  [offers]="offers$ | async"
  [selected]="selected$ | async"
  [itemOffer]="itemOffer$ | async"
></app-add-protection>

<app-loader
  [@fadeInOut]
  *ngIf="(additionalServicesService.itemOfferLoaded$ | async) === false"
></app-loader>
